import { createSlice } from "@reduxjs/toolkit";
import { animateCss } from "../../../pages/TosterAlert";
import {
  searchCaseDocumentsAction,
  searchCaseDocumentsByCaseTagsAction,
} from "../../actions/CaseDocuments/caseDocumentsAction";

const caseDocuments = {
  searchResults: null,
  loading: false,
  error: null,
};

const caseDocumentsSlice = createSlice({
  name: "caseDocuments",
  initialState: caseDocuments,
  reducers: {
    /** Reset the search Results */
    clearSearchResults: (state) => {
      state.searchResults = null;
      state.error = null;
    },
  },
  extraReducers: (builder) =>
    builder
      /* -------------------------------------------------
         NEW: searchCaseDocumentsAction
         ------------------------------------------------- */
      .addCase(searchCaseDocumentsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchCaseDocumentsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.searchResults = action.payload; // { caseID, documents }
      })
      .addCase(searchCaseDocumentsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? "Failed to search documents";
        state.searchResults = null;
      })
      .addCase(searchCaseDocumentsByCaseTagsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        searchCaseDocumentsByCaseTagsAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.searchResults = action.payload; // { caseID, documents }
        },
      )
      .addCase(
        searchCaseDocumentsByCaseTagsAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error =
            action.payload ?? "Failed to search documents by Case Tags";
          state.searchResults = null;
        },
      ),
});

export const { clearSearchResults } = caseDocumentsSlice.actions;
export default caseDocumentsSlice.reducer;
